import { Project } from '@/models/Project';
import { useTranslation } from 'react-i18next';
import { ProjectSectionContainer } from './ProjectSectionContainer';

export const ProjectVideo = ({ video }: Pick<Project, 'video'>) => {
  const { t: tField } = useTranslation('translation', {
    keyPrefix: 'projects.fields',
  });

  return (
    <ProjectSectionContainer title={tField('video.label')}>
      <video
        src={video}
        controls
        about={tField('video.filename')}
        title={tField('video.filename')}
        height={600}
        className="w-full rounded-md"
      />
    </ProjectSectionContainer>
  );
};
